import { Link, LinkProps } from "@components/Link";

export const FeedbackLink = ({ onClick, ...rest }: Omit<LinkProps, "to">) => {
  return (
    <Link {...rest} to="https://support.every.org/hc/en-us/requests/new" />
  );
};
